var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612_8804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.04167 11.875L7.04167 6.45833L11.375 6.45833V11.875H7.04167ZM1.625 7.54167L1.625 2.125L5.95833 2.125L5.95833 7.54167L1.625 7.54167ZM4.875 6.45833L4.875 3.20833L2.70833 3.20833L2.70833 6.45833L4.875 6.45833ZM1.625 11.875L1.625 8.625H5.95833L5.95833 11.875L1.625 11.875ZM2.70833 10.7917H4.875V9.70833H2.70833L2.70833 10.7917ZM8.125 10.7917H10.2917V7.54167H8.125L8.125 10.7917ZM7.04167 2.125L11.375 2.125V5.375H7.04167L7.04167 2.125ZM8.125 3.20833V4.29167H10.2917V3.20833L8.125 3.20833Z",
    fill: "#673C8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612_8804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.a4f5c3eef618bb90ea3a2d4bb1fdb44e.svg";
export { ForwardRef as ReactComponent };